<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <!-- <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="400px" class="mavSmallMenu">
            <v-toolbar flat>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="title">
                      {{ glapplnInt | glapplnIntDesc }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-toolbar>
            <v-list class="pt-0">
              <v-divider></v-divider>
              <v-list-item v-for="(item) in sideMenu" :key="item.name" :to="{ name: item.name, params: item.params }">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container> -->
    <v-card>
      <v-toolbar v-if="this.glapplnInt === 'new'">
        <v-icon right>mdi-plus</v-icon>
        <v-toolbar-title>{{ glapplnInt | glapplnIntDesc }}</v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-else>
        <v-toolbar-title>{{ glapplnInt | glapplnIntDesc }}</v-toolbar-title>
      </v-toolbar>
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { glAppInterface } from '@/const/acct/glAcct'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      title: 'Manage GL Mapping and Interface',
      breadcrumb: [],
      sideMenu: [{ name: 'mapFactor', text: 'Map Factor' }],
      sideFunction: [
        {
          text: 'Map Factor',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'mapFactor' }
        }
      ],
      glapplnIntDesc: null
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('glMapping'))
    if (jsonData) {
      this.$store.commit('GLMAPPING_COMMIT_KEY', jsonData)
    }
    this.breadcrumb = this.derieveBreadcrumbByName('glMapping')
    this.breadcrumb.push({
      text: this.title
    })
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doInit() {
      // this.$router.push({ name: 'mapFactor' })
      if (this.glapplnInt !== 'new') {
        this.sideMenu.push({ name: 'glInterface', text: 'GL Interface' })
        this.sideFunction.push({
          text: 'GL Interface',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'glInterface' }
        })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem('glMapping')
    next()
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.glAcctParam.menu
    }
  },
  filters: {
    glapplnIntDesc(value) {
      return value === 'new' ? 'Create New GL Mapping' : value + ' - ' + glAppInterface[value]
    }
  },
  watch: {
    glapplnInt(newVal, oldVal) {
      if (oldVal === 'new') {
        this.doInit()
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  props: ['glapplnInt']
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
.smallMenu {
  width: 400px;
}
</style>
